import React, { useState, useEffect } from 'react';
import { Search, Menu, ChevronRight } from 'lucide-react';
import './Details.scss';
import BackLogo from '../../../../../../images/rewampimages/Chevron.png'
import { getHubHeirarchyById, DownloadAgentDatabyId } from '../ActionCreator';
import Loader from '../../../../../presentationals/Loader/Loader.component'

const HubDashboard = ({ handleTabchange, EditData, handlecurrentTab, handleData }) => {
    const [Data, setData] = useState({})
    const [loader, setLoader] = useState(false)

    useEffect(() => {
        getHubHeirarchyByIdFn()
    }, [])

    const getHubHeirarchyByIdFn = () => {
        setLoader(true)
        getHubHeirarchyById(EditData?.hubId, callback => {
            setLoader(false)
            setData(callback?.data || {})
        })
    }

    const handleAgentInfo = (data) => {
        handleData(data)
        handlecurrentTab("AmuAgentDetail")
    }

    const handleDownloadReport = () => {
        setLoader(true)
        DownloadAgentDatabyId(Data?.hubId, "", "", "", "", "", callback => {
            setLoader(false)
        })
    }


    return (
        <>
            {
                loader ? <Loader /> : ""
            }
            <div className="dashboard">
                <header className="dashboard-header">
                    <div className="header-left">
                        <div onClick={(e) => handleTabchange("list", "")} style={{ display: 'inline-flex', flexDirection: 'row', gap: '5px', alignItems: 'center' }}>
                            <div>
                                <img src={BackLogo} alt="" width={'70%'} style={{ marginRight: '10px', cursor: 'pointer', flexShrink: '0' }} />
                            </div>
                            <div >
                                <h1 className="dashboard-title"  > {Data?.hubName}</h1>
                                <p className="hub-subtitle" style={{ marginBottom: '0' }}>{Data?.address}</p>
                            </div>
                        </div>
                    </div>
                    <div className="header-right">
                        {/* <div className="search-box">
            <Search size={20} className="search-icon" />
            <input 
              type="text" 
              placeholder="Search hubs, agents..." 
              className="search-input"
            />
          </div>
          <button className="add-hub-button">
            + Add New Hub
          </button> */}
                    </div>
                </header>

                <main className="dashboard-content">
                    <div className="customcardbox">
                        <div className="manager-card">
                            <div className="manager-info" style={{ position: 'relative' }}>
                                <div className="avatar-circle blue">
                                    {Data?.hubManager?.name?.charAt(0)?.toUpperCase()}
                                </div>
                                <div className="manager-details">
                                    <p className="manager-label">Hub Manager</p>
                                    <h3 className="manager-name">{Data?.hubManager?.name}</h3>
                                    <div className="contact-info">
                                        <span className="contact-item">📧 {Data?.hubManager?.email}</span>
                                        <span className="contact-separator">•</span>
                                        <span className="contact-item">📱 {Data?.hubManager?.mobile}</span>
                                    </div>
                                </div>
                                <div style={{ position: 'absolute', top: '0', right: '0' }}>
                                    <button className='btn ' style={{ background: '#064254', color: "#fff", borderRadius: '8px' }} onClick={() => handleDownloadReport()}><i className='fa fa-download'></i></button>
                                </div>
                            </div>
                        </div>

                        <div className="stats-grid">
                            <div className="stat-card">
                                <p className="stat-label">AMU Agents</p>
                                <p className="performance-value">{Data?.totalAmuAgents ?? 0}</p>
                            </div>
                            <div className="stat-card">
                                <p className="stat-label">Total Dealers</p>
                                <p className="performance-value">{Data?.totalDealers ?? 0}</p>
                            </div>
                            <div className="stat-card">
                                <p className="stat-label">Dealer Agents</p>
                                <p className="performance-value">{Data?.totalSalesAgents ?? 0}</p>
                            </div>
                            <div className="stat-card">
                                <p className="performance-label">Avg Performance</p>
                                <p className="performance-value" style={{ color: "#10b981" }}>{Data?.hubPerformance?.conversionRate ?? 0}%</p>
                            </div>
                        </div>
                    </div>


                    <div className="agents-section">
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <h3 className="section-title">AMU Agents</h3>
                            <h6 style={{ margin: '0 0 24px 0', fontSize: '15px', cursor: 'pointer', color: '#267dff' }} onClick={() => handlecurrentTab("amuAgentList")}><i className='fa fa-eye' style={{ color: '#267dff' }}></i> View</h6>
                        </div>
                        <div className="row ">
                            {Array.isArray(Data?.amuAgents) && Data?.amuAgents?.length > 0 ? Data?.amuAgents?.map((agent, id) => (
                                <div className='col-sm-6 col-xs-12' key={id} style={{ marginTop: '25px' }}>
                                    <div className="agent-card" onClick={() => handleAgentInfo(agent?.communityId || "")}>
                                        {
                                            agent?.isManager == true ?
                                                <div className='customManagerSvg'>
                                                    <svg
                                                        // fill="#ffc905"
                                                        fill="#10b981"
                                                        height="25px"
                                                        width="25px"
                                                        version="1.1"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        viewBox="0 0 297 297"
                                                        // stroke="#ffc905"
                                                        stroke="#d1fae5"
                                                    >
                                                        <g>
                                                            <path d="M110.549,98.768c27.231,0,49.384-22.154,49.384-49.384c0.001-27.231-22.153-49.384-49.384-49.384s-49.384,22.153-49.384,49.384C61.165,76.614,83.318,98.768,110.549,98.768z"></path>
                                                            <path d="M226.823,185.307c-30.794,0-55.846,25.053-55.846,55.846c0,30.794,25.053,55.846,55.846,55.846s55.846-25.053,55.846-55.846C282.669,210.36,257.617,185.307,226.823,185.307z M260.84,229.554l-36.494,36.494c-1.836,1.835-4.241,2.753-6.647,2.753c-2.406,0-4.811-0.918-6.647-2.753l-18.247-18.247c-3.671-3.671-3.671-9.623,0-13.294c3.672-3.67,9.622-3.67,13.294,0l11.6,11.601l29.847-29.848c3.672-3.67,9.622-3.67,13.294,0C264.511,219.931,264.511,225.883,260.84,229.554z"></path>
                                                            <path d="M206.751,172.72v-8.713c0-18.793-12.077-35.457-29.935-41.307l-0.083-0.027l-26.121-4.325c-2.223-0.684-4.599,0.493-5.398,2.686l-29.638,81.319c-1.71,4.691-8.345,4.691-10.055,0l-29.638-81.319c-0.646-1.771-2.317-2.881-4.108-2.881c-0.425,0-27.41,4.514-27.41,4.514c-18.005,6-30.035,22.691-30.035,41.565v67.664c0,10.14,8.22,18.36,18.36,18.36h123.405c-0.382-2.984-0.601-6.017-0.601-9.103C155.495,208.792,177.165,181.413,206.751,172.72z"></path>
                                                            <path d="M121.487,113.395c-1.157-1.26-2.848-1.895-4.558-1.895h-12.759c-1.711,0-3.402,0.634-4.558,1.895c-1.791,1.951-2.051,4.769-0.779,6.972l6.82,10.282l-3.193,26.934l6.287,16.725c0.613,1.682,2.992,1.682,3.605,0l6.287-16.725l-3.193-26.934l6.82-10.282C123.538,118.166,123.278,115.348,121.487,113.395z"></path>
                                                        </g>
                                                    </svg>

                                                </div>
                                                : ''}
                                        <div className="agent-info">
                                            <div className="avatar-circle green">
                                                {agent?.name?.charAt(0)?.toUpperCase() || ""}
                                            </div>
                                            <div className="agent-details">
                                                <h4 className="agent-name">{agent?.name || ""}</h4>
                                                <div className="agent-stats">
                                                    <span className="agent-stat">
                                                        🏢 {agent?.dealerCount || 0} Dealers
                                                    </span>
                                                    <span className="agent-stat">
                                                        👥 {agent?.performance?.totalLeads || 0} Total Leads
                                                    </span>
                                                    <span className="agent-stat">
                                                        👥 {agent?.performance?.convertedLeads || 0} Converted Leads
                                                    </span>
                                                    <span className={`agent-performance ${agent?.performance?.conversionRate >= 90 ? 'high' : agent?.performance?.conversionRate > 40 && agent?.performance?.conversionRate < 90 ? 'medium' : 'low'}`}>
                                                        📊 {agent?.performance?.conversionRate || 0}%
                                                    </span>
                                                </div>
                                            </div>
                                            <div className='rightArrowShow'>
                                                <i class="fa fa-angle-double-right" aria-hidden="true"></i>
                                            </div>
                                        </div>
                                        {/* <ChevronRight size={24} className="chevron-icon" /> */}
                                    </div>
                                </div>
                            )) :
                                <div className='text-center' style={{ margin: '20px 0' }}>
                                    <p className="stat-label" style={{ marginBottom: '0' }}>No AMU Agent Mapped yet</p>
                                </div>
                            }
                        </div>
                    </div>

                </main>
            </div>
        </>
    );
};

export default HubDashboard;